/* eg-oregano-stats — the four figures count up once the whole band is on
   screen.

   Each value keeps its written form in the markup ("2,000+", "7,000mg", "1M+"),
   so it is correct with no JavaScript at all. Here the number inside it is
   parsed out, reset to zero and run up to its value once, when the band is
   fully in view; the prefix, the suffix and the thousands grouping are put back
   on every frame. */
(function () {
  'use strict';

  var DURATION = 1000;
  var SHAPE = /^([^\d]*)([\d][\d.,]*)(.*)$/;

  function reduced() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  // slow at the end, so the last digits settle rather than snap
  function ease(t) {
    return 1 - Math.pow(1 - t, 3);
  }

  function parse(el) {
    var match = SHAPE.exec(el.textContent.trim());
    if (!match) return null;

    var digits = match[2];
    var decimals = digits.indexOf('.') === -1 ? 0 : digits.length - digits.indexOf('.') - 1;

    var target = parseFloat(digits.replace(/,/g, ''));

    return {
      prefix: match[1],
      suffix: match[3],
      target: target,
      grouped: digits.indexOf(',') !== -1,
      decimals: decimals,
      /* "1M+" would only ever read 0 then 1; a decimal while it runs gives it
         something to count, and the plain figure lands at the end */
      running: decimals === 0 && target < 10 ? 1 : decimals
    };
  }

  function format(value, shape, decimals) {
    var text = decimals ? value.toFixed(decimals) : String(Math.round(value));
    if (shape.grouped) text = text.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return shape.prefix + text + shape.suffix;
  }

  function run(el, shape) {
    var t0 = null;
    var done = false;

    function finish() {
      if (done) return;
      done = true;
      el.textContent = format(shape.target, shape, shape.decimals);
    }

    function step(now) {
      if (done) return;
      if (t0 === null) t0 = now;
      var t = Math.min(1, (now - t0) / DURATION);
      if (t >= 1) return finish();
      el.textContent = format(shape.target * ease(t), shape, shape.running);
      requestAnimationFrame(step);
    }

    requestAnimationFrame(step);
    // frames stop in a background tab; the figure must not be left at zero
    setTimeout(finish, DURATION + 400);
  }

  function init(root) {
    if (!root || root.dataset.egosInit === 'true') return;
    root.dataset.egosInit = 'true';

    var values = Array.prototype.slice.call(root.querySelectorAll('[data-egos-value]'));
    if (!values.length) return;

    var shapes = [];
    values.forEach(function (el) {
      var shape = parse(el);
      shapes.push(shape);
      // a figure with no number in it is left exactly as written
      if (shape && !reduced()) el.textContent = format(0, shape, shape.running);
    });

    if (reduced()) return;

    /* The count waits for the whole band to be on screen, so the figures never
       run while they are still down by the fold. The band is short enough to
       fit; if a narrow screen ever makes it taller than the viewport, filling
       the screen counts instead, otherwise the trigger could never be met. */
    function ready() {
      var box = root.getBoundingClientRect();
      var vh = window.innerHeight;
      if (box.height > vh) return box.top <= 0 && box.bottom >= vh;
      return box.top >= 0 && box.bottom <= vh;
    }

    var frame = 0;

    function start() {
      window.removeEventListener('scroll', check);
      window.removeEventListener('resize', check);
      if (frame) cancelAnimationFrame(frame);
      values.forEach(function (el, i) {
        if (shapes[i]) run(el, shapes[i]);
      });
    }

    /* Checked once per frame, not on a timer: a timer that resets on every
       scroll event only fires after the scrolling stops, which left the band
       sitting on screen for a moment before the figures moved. */
    function check() {
      if (frame) return;
      frame = requestAnimationFrame(function () {
        frame = 0;
        if (ready()) start();
      });
    }

    window.addEventListener('scroll', check, { passive: true });
    window.addEventListener('resize', check);
    if (ready()) start();
  }

  function boot() {
    var roots = document.querySelectorAll('[data-egos]');
    for (var i = 0; i < roots.length; i++) init(roots[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();
